<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Generelt</h2>
    </v-flex>
    <v-flex xs12 v-if="config.info">
      <span v-html="config.info" />
    </v-flex>
    <v-flex xs12 class="mb-2">
      <TextareaInput v-model="stepValues.comments" @update-fields="updateFields"></TextareaInput>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import TextareaInput from "../form/TextareaInput.vue";
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: { TextareaInput },
  mounted: function() {
    if(this.protocol.related_protocol) {
      if(this.protocol.related_protocol.steps.general.saved_values.comments && !this.protocol.related_protocol.steps.general.saved_values.loadedFromRelated) {
        this.protocol.related_protocol.steps.general.saved_values.loadedFromRelated = true
        let comments = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.general.saved_values.comments))
        for(let c in comments) {
          comments[c].relatedValue = comments[c].value
          comments[c].value = null
        }
        this.stepValues.comments = comments
      }
    }
  },
}
</script>
